import {
  Area,
  Bar,
  CartesianGrid,
  ComposedChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { handleEntriesTopMakes } from "../../../api/entries";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { ChevronRight } from "lucide-react";
import AllMakes from "./AllMakes";
import { Empty } from "antd";

interface MakeData {
  makeId: string;
  makeName: string;
  totalEntries: number;
  percentage: number;
}

interface ConvertedData {
  name: string;
  Percentage: number;
  Entries: number;
  fill: string;
}

export default function TopMakes({ filters }: any) {
  const [isVisible, setVisible] = useState<boolean>(false);
  const [limit, setLimit] = useState(5);
  function convertDataWithRandomColors(inputData: MakeData[]): ConvertedData[] {
    const convertedData: ConvertedData[] = [];

    for (const item of inputData) {
      const randomColor =
        "#" +
        Math.floor(Math.random() * 16777215)
          .toString(16)
          .padStart(6, "0");

      convertedData?.push({
        name: item.makeName,
        Percentage: item.percentage,
        Entries: item.totalEntries,
        fill: randomColor,
      });
    }

    return convertedData;
  }

  const params = `limit=${limit}&startDate=${filters?.startDate}&endDate=${filters?.endDate}&branch=${filters?.branch}`;

  const { data: entries } = useQuery({
    queryKey: ["topMakes", params],
    queryFn: () => handleEntriesTopMakes({ params }),
  });

  const data = convertDataWithRandomColors(entries || []);

  return (
    <div className="">
      <div className="border-b-4 border-orange-100 bg-orange-50 p-2  flex justify-between">
        <div className="font-bold">TOP 5 MAKES</div>
        <button
          onClick={() => setVisible(true)}
          className="flex justify-center items-center text-gray-600"
        >
          View All <ChevronRight size={15} />
        </button>
      </div>

      <div className="my-2" style={{ height: 350 }}>
        {!entries || entries?.length === 0 ? (
          <Empty />
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart
              layout="vertical"
              width={500}
              height={400}
              data={data}
              margin={{
                top: 20,
                right: 20,
                bottom: 0,
                left: 20,
              }}
            >
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis type="number" />
              <YAxis dataKey="name" type="category" scale="band" />
              <Tooltip />
              <Area dataKey="Percentage" fill="#8884d8" stroke="#8884d8" />
              <Bar dataKey="Entries" barSize={20} fill="#413ea0" />
            </ComposedChart>
          </ResponsiveContainer>
        )}
      </div>
      <AllMakes
        isVisible={isVisible}
        setVisible={setVisible}
        filters={filters}
      />
    </div>
  );
}
